import React from 'react';
import {useStoreState} from "easy-peasy";

export default function EmployeeDashboardHeader({header}){
	const displayName = useStoreState(state=>state.user.displayName);
	const lastUpdatedDate = useStoreState(state=>state.headerInfo.lastUpdated);

	return (
		<>
			{!!header && (

				<div style={{backgroundColor:header.color}} className={'dashboard-header employee full-width simple'}>
					<div className={'dashboard-header-holder max-width-container simple employee'}>
						<div className={'dashboard-header-content simple'}>
							<h1>{'Welcome back to Thrive ' + displayName}</h1>
							<p>{lastUpdatedDate !== 'hide' && header.subTitle.replace('%last_date',lastUpdatedDate)}</p>
							
							<a href={'#dashboard-details'} className={'down-anchor'} />
						</div>
						<a href={'https://calendly.com/silver-lion-team/student-loan-review-all'} className={'simple-rounded-button white small center round'} target='_blank' rel='noopener noreferrer'><span>Schedule Free Federal Loan Review</span></a>
					</div>
				</div>
			)
			}
		</>
	)
}
